import LazyLoad from './src/LazyLoad';
export default LazyLoad;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-lazy-load/index.js
// module id = null
// module chunks = 